import { createContext, ReactElement, useContext } from 'react';
import type {
  ISearchPageFilter,
  ISortField,
} from '../../api/types/searchPageApiTypes';
import { useFilters } from '../../features/filters/Filters.hook';
import {
  FilterState,
  FilterDispatch,
} from '../../features/filters/Filters.typed';

export const FilterDispatchContext = createContext({} as FilterDispatch);
export const FilterStateContext = createContext({} as FilterState);

export const useFiltersDispatch = (): FilterDispatch =>
  useContext(FilterDispatchContext);
export const useFiltersState = (): FilterState =>
  useContext(FilterStateContext);

export const FilterProvider = ({
  filtersData,
  sortFields,
  children,
}: {
  filtersData: ISearchPageFilter[];
  sortFields: ISortField[];
  children: ReactElement;
}): ReactElement => {
  const { state, dispatch } = useFilters(filtersData, sortFields);

  return (
    <FilterDispatchContext.Provider
      value={{
        ...dispatch,
      }}
    >
      <FilterStateContext.Provider
        value={{
          ...state,
        }}
      >
        {children}
      </FilterStateContext.Provider>
    </FilterDispatchContext.Provider>
  );
};
